import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ContactSupport from "../pages/contact-support/page";
import DisputeResolution from "../pages/dispute-resolution/page";
import CancelSubscription from "../pages/faq/cancel-subscription/page";
import AutoRenew from "../pages/faq/auto-renew/page";
import NotReceived from "../pages/faq/not-received/page";
import Refund from "../pages/faq/refund/page";
import UnrecognizedCharge from "../pages/faq/unrecognized-charge/page";
import UnawareCharges from "../pages/faq/unaware-charges/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/contact-support",
    element: <ContactSupport />,
  },
  {
    path: "/dispute-resolution",
    element: <DisputeResolution />,
  },
  {
    path: "/faq/cancel-subscription",
    element: <CancelSubscription />,
  },
  {
    path: "/faq/auto-renew",
    element: <AutoRenew />,
  },
  {
    path: "/faq/not-received",
    element: <NotReceived />,
  },
  {
    path: "/faq/refund",
    element: <Refund />,
  },
  {
    path: "/faq/unrecognized-charge",
    element: <UnrecognizedCharge />,
  },
  {
    path: "/faq/unaware-charges",
    element: <UnawareCharges />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;